<div class="abx-profile-menu">
  <button
    type="button"
    class="abx-profile-menu__avatar"
    [class.abx-profile-menu__avatar--open]="open()"
    [attr.aria-expanded]="open()"
    [attr.aria-label]="'Account menu for ' + displayName()"
    (click)="toggle()">
    <span class="abx-profile-menu__initials">{{ initials() }}</span>
  </button>

  @if (open()) {
    <div class="abx-profile-menu__dropdown" role="menu">
      <div class="abx-profile-menu__identity">
        <div class="abx-profile-menu__name">{{ displayName() }}</div>
        @if (user()?.email) {
          <div class="abx-profile-menu__email">{{ user()?.email }}</div>
        }
      </div>

      <a [routerLink]="accountUrl()" class="abx-profile-menu__item" role="menuitem" (click)="open.set(false)">
        <mat-icon>person</mat-icon> Account settings
      </a>

      <button
        type="button"
        class="abx-profile-menu__item abx-profile-menu__item--logout"
        role="menuitem"
        (click)="logout()">
        <mat-icon>logout</mat-icon> Log out
      </button>
    </div>
  }
</div>
